
	import {
		Component,
		Prop,
		Vue,
		Watch
	} from "vue-property-decorator";
	import upload from '@/utils/upload/uploadImg.js';
	import previewImg from './previewImg.vue';
	import { imgHost } from '@/utils/config';
	import draggable from 'vuedraggable'
import { remove } from "js-cookie";

	@Component({
		name: 'upload-img',
		components: {
			previewImg,
			draggable
		}
	})
	export default class extends Vue {
		@Prop({
			default: 'input'
		}) private type!: string;
		@Prop({
			default: ''
		}) private fileType!: string // image , video , file
		@Prop({
			default: true
		}) private multiple!: boolean;
		@Prop({}) extraData!: any;
		@Prop({
			default: 5
		}) private size_limit!: number
		@Prop({}) private limit!: number
		@Prop({}) private tips!: string;
		@Prop({
			default: false
		}) private isSingle!: boolean;
		@Prop({
			default: '点击上传'
		}) private placeholder!: string;
		@Prop({
			default: true
		}) private display!: boolean;
		@Prop({
			default: () => {
				return []
			}
		}) private fileList!: any;
		@Prop({}) private isLock!: boolean;
		@Prop({
			default: false
		}) private disabled: false;
		@Prop({
			default: false
		}) private hasexample: false;
		@Prop({default:'查看示例图'}) private exampleLabel!: string;
		@Prop({default:''}) private exampleUrl!: string;
		@Prop({default:false}) private IsFileShowName!: boolean;
		@Prop({default:false}) private canDown!: boolean;
		@Prop({default:()=>{
			return []
		}}) private definite!: string[];
		@Prop({default:'上传'}) private btnText!:string
		private key: number = Math.random() * parseInt(new Date().getTime() + '');
		private picList: any = []
		private noReload = true
		private operageIndex: any = null
		private hoverenter: any = null
		private currentUrl = ''
		private showPreview = false
		private imgHost = imgHost
		private fileIcon = {
			'xlsx':'routuan-xlsx',
			'xls':'routuan-xlsx',
			'pdf':'routuan-pdf',
			'word':'routuan-word',
		}
		private ShowFileType = 'image'
		
		@Watch('fileList')
		private onChangeFile(value: any) {
			// console.log(Array.isArray(val), 'val')
			// console.log(value)
			this.picList = []
			let val = JSON.parse(JSON.stringify(value))
			// console.log(val,693)
			this.picList = val.map((item: any) => {
				// console.log(item,11)
				let url:string = item&&(item.url||item.Url) ? (item.url||item.Url) : item;
				
				// if (url.indexOf('http') < 0 && url.indexOf('https') < 0){
				// 	url = imgHost + url;
				// }
				// console.log(item.name)
				// debugger
				let msg = {
					url: url,
					type: this.fileType,
					loading:false,
					name:item.name||item.Name,
					format:item.format

				}
				return msg
				// console.log(this.picList.map(v=>v.type),444)
			})
			// console.log(this.picList)
		}


		
		private toOnload(link,item){
			
			if(this.isImg(link)){
				var image = new Image()
				// 解决跨域 Canvas 污染问题 解决跨域问题-并不好使，需要改对应的请求服务器
				image.setAttribute('crossOrigin', 'anonymous')
				image.onload = () => {
					var canvas:any = document.createElement('canvas')
					canvas.width = image.width
					canvas.height = image.height

					var context = canvas.getContext('2d')
					context.drawImage(image, 0, 0, image.width, image.height)
					var url = canvas.toDataURL('image/png')

					// 生成一个a元素
					var a = document.createElement('a')
					// 创建一个单击事件
					var event = new MouseEvent('click')

					// 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
					a.download = link
					// 将生成的URL设置为a.href属性
					a.href = url
					// 触发a的单击事件
					a.click()
				}
				image.src = location.origin+'/image/server?url='+this.imgHost+link
			}else if(this.isVideo(link)){
				var xhr = new XMLHttpRequest();
        xhr.open('GET', location.origin+'/image/server?url='+this.imgHost+link, true);
        xhr.responseType = 'arraybuffer';    // 返回类型blob
        xhr.onload = function () {
             if (xhr.readyState === 4 && xhr.status === 200) {
                  let blob = this.response;
                  // 转换一个blob链接
                  let u = window.URL.createObjectURL(new Blob([blob],{ type: 'video/mp4' }))
                  let a:any = document.createElement('a');
                  a.download = link;
                  a.href = u;
                  a.style.display = 'none'
                  document.body.appendChild(a)
                  a.click();
                  a.remove();
             }
        };
        xhr.send()
			}else{
				// window.open(this.imgHost+link)
				this.iframDown(this.imgHost+link,item)
			}
		}
		private iframDown(url,item){
			const xhr:any = new XMLHttpRequest();
			xhr.open('GET', location.origin+'/image/server?url='+url, true);
			xhr.responseType = 'blob'; // 设置响应类型为blob
			xhr.onload = function(e) {
				console.log(this,1)
				if (this.status === 200) {
					const blob = this.response; // 获取blob对象
					console.log(blob);
					const link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					link.download = item.name;
					link.target = '_blank';
					// return
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					URL.revokeObjectURL(blob)
				}
			};
			xhr.send();
						
			// const iframe:any = document.createElement("iframe");
			// iframe.style.display = "none";
			// iframe.style.height = 0
			// iframe.src = url
			// document.body.appendChild(iframe);
			// setTimeout(()=>{
			// 	iframe.remove()
			// },1000)
		}
		private isVideo(name){
			const videoExtensions = /\.(mp4|webm|ogg)$/i;
  		return videoExtensions.test(name);
		}
		private isImg(name){
			const imageExtensions = /\.(jpg|jpeg|png|gif|bmp)$/i;
  		return imageExtensions.test(name)
		}
		private downfile(v,i){
			if(!this.canDown) return 
			// window.open(this.imgHost+v.url)
			this.iframDown(this.imgHost+v.url,v)
		}
		private getpreivewlist(){
			// console.log(this.fileList)
			return this.fileList.map(v=>{
				return this.imgHost + v
			})
		}
		private start(){
			// console.log(this.picList.map(v=>v.url))
		}
		//拖拽结束
		private draggableEnd(list){	
			// console.log(list)
			// this.picList = list
			if(this.IsFileShowName){
				this.$emit('success', this.picList);
			}else{
				this.$emit('success', this.transferList(this.picList));
			}
		}

		created () {
			
		}
		private mounted() {
			this.watchDrag()
			this.onChangeFile(this.fileList)
		}

		/**
		 * @func 遍历文件数据
		 * @param files
		 */
		private forEachData(files: any) {
			// console.log(this.picList)
			const len = this.picList.length
			// 文件数限制
			if (this.limit && !this.isSingle && this.noReload) {
				if (files.length > this.limit || (files.length + len) > this.limit) {
					this.$message('最多上传' + this.limit + '个文件')
					return
				}
			}
			//文件具体类型限制
			if(this.definite&&this.definite.length){
				for(let item of files){
					let types = item.name.split('.')
					let type = '.' + types[types.length-1]
					if(!this.definite.some(v=>v==type)){
						this.$message('仅支持导入'+ this.definite.join(';') +'文件')
						return 
					}
				}
			}
			// 单图片
			if (this.isSingle) {
				if (!this.getSuffix(files[0])) {
					return;
				}
				this.uploadFile(files[0], 0);
				return;
			}
			// 多图片重新上传
			if (!this.noReload && this.operageIndex !== null) {
				if (!this.getSuffix(files[0])) {
					return;
				}
				this.uploadFile(files[0], this.operageIndex);
				this.noReload = true;
				this.operageIndex = null;
				return;
			}


			for (let i = len; i < files.length + len; i++) {
				const l = i - len;
				if (!this.getSuffix(files[l])) {
					break
				}
				this.picList.push({
					url: '',
					type: this.fileType,
					loading:false,
					name:files[l].name,
					format:''
				})
				// console.log(this.picList,1)
				this.uploadFile(files[l], i)
			}
		}

		/**
		 * @func 获取文件名后缀
		 * @param file
		 */
		private getSuffix(file: any) {
			const refs: any = this.$refs.upload;
			if (this.size_limit&&this.size_limit!=0) {
				const size = file.size / 1024 / 1024
				if (size > this.size_limit) {
					this.$message('上传文件大小不能超过' + this.size_limit + 'M')
					refs.value = null;
					return false
				}
			}

			if (this.fileType !== 'file' && this.fileType !== 'all' && file.type.indexOf(this.fileType) === -1) {
				this.$message({
					message: '请上传正确文件格式',
				})
				refs.value = null;
				return false
			}
			return true
		}

		/**
		 * @func 获取选择的文件
		 * @param file
		 */
		private selectPhoto(file: any) {
			this.forEachData(file.target.files);
			file.target.value = ''
		}

		/**
		 * @func 拖动文件到指定区域
		 * @param e
		 */
		private enterDrop(e: any) {
			e.stopPropagation()
			e.preventDefault()
			this.forEachData(e.dataTransfer.files)
		}

		/**
		 * @func 拖拽监听
		 * @param none
		 */
		private watchDrag() {
			const dropbox: any = document.getElementById('drag_area_' + this.key)
			if (!dropbox) return;
			dropbox.addEventListener('drop', this.enterDrop, false)
			dropbox.addEventListener('dragleave', function(e: any) {
				e.stopPropagation()
				e.preventDefault()
			})
			dropbox.addEventListener('dragenter', function(e: any) {
				e.stopPropagation()
				e.preventDefault()
			})
			dropbox.addEventListener('dragover', function(e: any) {
				e.stopPropagation()
				e.preventDefault()
			})
		}

		private handleClick() {
			if (this.isLock || this.disabled) return;
			const refs: any = this.$refs.upload;
			refs.click();
		}

		/**
		 * @func 重新上传
		 * @param index 当前操作的index
		 */
		private toReUpload(index: number) {
			this.operageIndex = index;
			this.noReload = false
			this.handleClick();
		}

		/**
		 * @func 删除
		 * @params index 图片的序号
		 */
		private delPic(index: number) {
			if(this.disabled) return 
			this.picList.splice(index, 1);
			if(this.IsFileShowName){
				this.$emit('success', this.picList);
			}else{
				this.$emit('success', this.transferList(this.picList));
			}
		}

		/**
		 * @func 上传
		 * @param file 文件数据
		 * @param index 第几个文件
		 */
		private uploadFile(file: any, index: number) {
			let names = file.name.split('.');
			let last = names[names.length-1];
			let fileName = file.name.replace('.'+last, '')+this.guid()+'.'+last;
			let fileType = this.isImg(file.name)?'image':'File'
			//上传之前就需要设一个默认值 不然在其他配置改变时上传的样式会消失
			if(fileType!='image'){
				// console.log(this.picList,index)
				if(!this.picList||!this.picList.length){
					this.picList.push({
						url:'',
						loading:false,
						type:this.fileType,
						name:file.name
					})
				}
				// console.log(this.picList[index])
				this.picList[index].url = 'url'+file.name
				this.picList[index].loading = true
			}
			let data = {
				file:file,
				fileType:fileType,
				other:{FileNames: [fileName]},
				extraData:this.extraData
			}
			// console.log(data)
			upload(file,  fileType, {FileNames: [fileName]}, this.extraData, 
				(res: any) => {
					this.hoverenter = null
					// console.log(res)
					let row = {
						url:res,
						type: this.fileType,
						name: file.name,
						loading:false,
						format:last
					}
					this.$set(this.picList,index,row);
					if(this.IsFileShowName){
						// console.log(this.picList,'11111')
						this.$emit('success', this.picList);
					}else{
						this.$emit('success', this.transferList(this.picList), fileName,file.name);
					}
				}, (error: any) => {
					this.picList.splice(index,1)
					if(this.IsFileShowName){
						this.$emit('success', this.picList);
					}else{
						this.$emit('success', this.transferList(this.picList), fileName,file.name);
					}
					this.$message.error('上传失败')
				}
			)
		}
		private guid() {
			var a = function() {
				return (65536 * (1 + Math.random()) | 0).toString(16).substring(1)
			};
			return a() + a() + "-" + a() + "-" + a() + "-" + a() + "-" + a() + a() + a()
		}
		/**
		 * @func 获取图片列表
		 * @param list
		 */
		private transferList(list: any) {
			const l: any = []
			list.map((res: any) => {
				l.push(res.url)
			})
			return l
		}

		/**
		 * @func 预览
		 * @param url 需要预览的链接
		 */
		private preview(url: string) {
			this.currentUrl = url;
			// console.log(url)
			this.hoverenter = null
			this.showPreview = true;
			if(this.isImg(url)){
				this.ShowFileType = 'image'
			}else if(this.isVideo(url)){
				this.ShowFileType = 'video'
			}else{
				this.ShowFileType = ''
			}
			
		}
	}
